// selectors.js
import { da } from 'date-fns/locale';
import { createSelector } from 'reselect';

// Basic input selectors
const selectState = (state) => state;
const selectLoader = (state) => state.loading || {};
const selectPageLoader = (state) => state?.paginationLoading || {};
const selectData = (state) => state?.data || {};
const selectUserInfo = (state) => state.data?.userInfo?.user;
const selectUserMenuDetail = (state) => state.data?.userDetail?.userUIControlPermission;
const selectUserRole = (state) => state.data?.userDetail?.userInformation?.role;
const selectUserInformation = (state) => state.data?.userDetail?.userInformation;
const selectUserAccessPermissions = (state) => state.data?.userDetail?.accessPermissions;
const selectUserActivity = (state) => state.data?.userDetail?.userActivity;
const selectDashboardTask = (state) => state.data?.dashboardTask?.assignmentAndMilestone;
const selectAssignmentDeadline = (state) => state.data?.assignmentDeadline?.assignmentDeadline;
const selectOverdueTask = (state) => state.data?.overdueAssignmentsCount?.overdueAssignmentsCount;
const selectDashboardActiveProjectCount = (state) => state.data?.dashboardActiveProjectCount;
const selectUserTimelogSettings = (state) => state.data?.userTimelogSettings?.userTimelogSettings;
const selectUserLogHours = (state) => state.data?.userLogHours;
const selectUnfilledTimesheet = (state) =>
  state.data?.unfilledTimesheetDates?.unfilledTimesheetDates;
const selectProjectList = (state) => state.data?.dashboardProjects?.projects;
const selectActiveClient = (state) => state.data?.dashboardActiveClientCount;
const selectInActiveClient = (state) => state.data?.dashboardInActiveClientCount;
const selectUserList = (state) => state.data?.userList;

// Memoized selectors
export const getUserInfo = createSelector([selectUserInfo], (userInfo) => userInfo?.user);

// export const getUserMenuPermission = (menuKey) =>
//   createSelector([selectUserMenuDetail], (data) => (data[menuKey] ? data[menuKey] : null));

export const getUserMenuPermission = createSelector([selectUserMenuDetail], (data) => data);
export const getUserRole = createSelector([selectUserRole], (data) => data);
export const getUserInformation = createSelector([selectUserInformation], (data) => data);
export const getUserAccessPermissions = createSelector(
  [selectUserAccessPermissions],
  (data) => data
);
export const getUserActivity = createSelector([selectUserActivity], (data) => data);

export const getDashboardTask = createSelector(
  [selectDashboardTask],
  (dashboardTask) => dashboardTask
);

export const getAssignmentDeadline = createSelector(
  [selectAssignmentDeadline],
  (assignmentDeadline) => assignmentDeadline
);

export const getOverdueTask = createSelector([selectOverdueTask], (overdueTask) => overdueTask);

export const getDashboardActiveProjectCount = createSelector(
  [selectDashboardActiveProjectCount],
  (dashboardActiveProjectCount) => dashboardActiveProjectCount
);

export const getUserLogHours = createSelector([selectUserLogHours], (userLogHours) => userLogHours);

export const getUnfilledTimesheet = createSelector(
  [selectUnfilledTimesheet],
  (unfilledTimesheet) => unfilledTimesheet
);

export const getDashboardProjectList = createSelector(
  [selectProjectList],
  (projectList) => projectList
);

export const getDashboardActiveClient = createSelector(
  [selectActiveClient],
  (activeClientList) => activeClientList
);

export const getAttendanceByUserId = createSelector(
  [selectData],
  (data) => data?.attendanceByUserId ? data?.attendanceByUserId : null
);

export const getDashboardInActiveClient = createSelector(
  [selectInActiveClient],
  (activeInClientList) => activeInClientList
);

export const getProjects = createSelector([selectData], (data) =>
  data.projects ? data.projects.projects : []
);

// export const getStatus = createSelector(
//   [selectData],
//   (data) => data.status || []
// );

//   export const getStatus = createSelector(
//   [selectData],
//   (data) => data.genericMasterFilteredList?.filter(item => item.type === "Status") || []
// );

// export const getGroups = createSelector(
//   [selectData],
//   (data) => data.groups || []
// );

// export const getDurationChangeReasonList = createSelector(
//   [selectData],
//   (data) => data.durationChangeReason || []
// );

// export const getFlags = createSelector(
//   [selectData],
//   (data) => data.flags || []
// );

// export const getPriorities = createSelector(
//   [selectData],
//   (data) => data.priorities || []
// );

// export const getProjectTypes = createSelector(
//   [selectData],
//   (data) => data.projectTypes || []
// );

// export const getTaskTags = createSelector(
//   [selectData],
//   (data) => data.taskTags || []
// );

// export const getAssignmentBillingStatus = createSelector(
//   [selectData],
//   (data) => data.assignmentBillingStatus || []
// );

// export const getProjectBillingStatus = createSelector(
//   [selectData],
//   (data) => data.projectBillingStatus || []
// );

export const getGenericMasterFilteredListByKey = (key) =>
  createSelector([selectData], (data) =>
    data?.genericMasterFilteredList && key in data?.genericMasterFilteredList
      ? data?.genericMasterFilteredList[key]
      : []
  );

// export const getStatus = createSelector([selectData], (data) => {
//   const filteredGroup = data?.genericMasterFilteredList?.filter(
//     (item) => item.type === "Status"
//   );
//   return filteredGroup && filteredGroup.length > 0
//     ? filteredGroup[0]?.data || []
//     : [];
// });

// export const getRevenueTypeList = createSelector([selectData], (data) => {
//   const filteredGroup = data?.genericMasterFilteredList?.filter(
//     (item) => item.type === "RevenueType"
//   );
//   return filteredGroup && filteredGroup.length > 0
//     ? filteredGroup[0]?.data || []
//     : [];
// });

// export const getLeadSourceList = createSelector([selectData], (data) => {
//   const filteredGroup = data?.genericMasterFilteredList?.filter(
//     (item) => item.type === "LeadSource"
//   );
//   return filteredGroup && filteredGroup.length > 0
//     ? filteredGroup[0]?.data || []
//     : [];
// });

// export const getIndustryList = createSelector([selectData], (data) => {
//   const filteredGroup = data?.genericMasterFilteredList?.filter(
//     (item) => item.type === "Industry"
//   );
//   return filteredGroup && filteredGroup.length > 0
//     ? filteredGroup[0]?.data || []
//     : [];
// });

// export const getAccountType = createSelector([selectData], (data) => {
//   const filteredGroup = data?.genericMasterFilteredList?.filter(
//     (item) => item.type === "AccountType"
//   );
//   return filteredGroup && filteredGroup.length > 0
//     ? filteredGroup[0]?.data || []
//     : [];
// });

// export const getTimeZone = createSelector([selectData], (data) => {
//   const filteredGroup = data?.genericMasterFilteredList?.filter(
//     (item) => item.type === "TimeZone"
//   );
//   return filteredGroup && filteredGroup.length > 0
//     ? filteredGroup[0]?.data || []
//     : [];
// });

// export const getSalutation = createSelector([selectData], (data) => {
//   const filteredGroup = data?.genericMasterFilteredList?.filter(
//     (item) => item.type === "Salutation"
//   );
//   return filteredGroup && filteredGroup.length > 0
//     ? filteredGroup[0]?.data || []
//     : [];
// });

// export const getContactPersonRole = createSelector([selectData], (data) => {
//   const filteredGroup = data?.genericMasterFilteredList?.filter(
//     (item) => item.type === "ContactPersonRole"
//   );
//   return filteredGroup && filteredGroup.length > 0
//     ? filteredGroup[0]?.data || []
//     : [];
// });

// export const getStage = createSelector([selectData], (data) => {
//   const filteredGroup = data?.genericMasterFilteredList?.filter(
//     (item) => item.type === "Stage"
//   );
//   return filteredGroup && filteredGroup.length > 0
//     ? filteredGroup[0]?.data || []
//     : [];
// });

// export const getCampaignSource = createSelector([selectData], (data) => {
//   const filteredGroup = data?.genericMasterFilteredList?.filter(
//     (item) => item.type === "CampaignSource"
//   );
//   return filteredGroup && filteredGroup.length > 0
//     ? filteredGroup[0]?.data || []
//     : [];
// });

// export const getCampaignMemberStatus = createSelector([selectData], (data) => {
//   const filteredGroup = data?.genericMasterFilteredList?.filter(
//     (item) => item.type === "CampaignMemberStatus"
//   );
//   return filteredGroup && filteredGroup.length > 0
//     ? filteredGroup[0]?.data || []
//     : [];
// });

// export const getForecastCategory = createSelector([selectData], (data) => {
//   const filteredGroup = data?.genericMasterFilteredList?.filter(
//     (item) => item.type === "ForecastCategory"
//   );
//   return filteredGroup && filteredGroup.length > 0
//     ? filteredGroup[0]?.data || []
//     : [];
// });

// export const getProjectTypeCrm = createSelector([selectData], (data) => {
//   const filteredGroup = data?.genericMasterFilteredList?.filter(
//     (item) => item.type === "ProjectTypeCrm"
//   );
//   return filteredGroup && filteredGroup.length > 0
//     ? filteredGroup[0]?.data || []
//     : [];
// });

// export const getTicketPriority = createSelector([selectData], (data) => {
//   const filteredGroup = data?.genericMasterFilteredList?.filter(
//     (item) => item.type === "TicketPriority"
//   );
//   return filteredGroup && filteredGroup.length > 0
//     ? filteredGroup[0]?.data || []
//     : [];
// });

// export const getTicketStatus = createSelector([selectData], (data) => {
//   const filteredGroup = data?.genericMasterFilteredList?.filter(
//     (item) => item.type === "TicketStatus"
//   );
//   return filteredGroup && filteredGroup.length > 0
//     ? filteredGroup[0]?.data || []
//     : [];
// });

// export const getCampaignType = createSelector([selectData], (data) => {
//   const filteredGroup = data?.genericMasterFilteredList?.filter(
//     (item) => item.type === "CampaignType"
//   );
//   return filteredGroup && filteredGroup.length > 0
//     ? filteredGroup[0]?.data || []
//     : [];
// });

// export const getCampaignStatus = createSelector([selectData], (data) => {
//   const filteredGroup = data?.genericMasterFilteredList?.filter(
//     (item) => item.type === "CampaignStatus"
//   );
//   return filteredGroup && filteredGroup.length > 0
//     ? filteredGroup[0]?.data || []
//     : [];
// });

// export const getGroups = createSelector(
//   [selectData],
//   (data) => {
//     const filteredGroup = data?.genericMasterFilteredList?.filter(item => item.type === "Group");
//     return filteredGroup && filteredGroup.length > 0 ? filteredGroup[0]?.data || [] : [];
//   }
// );

// export const getDurationChangeReasonList = createSelector(
//   [selectData],
//   (data) => {
//     const filteredGroup = data?.genericMasterFilteredList?.filter(item => item.type === "ProjectDurationChangeReason");
//     return filteredGroup && filteredGroup.length > 0 ? filteredGroup[0]?.data || [] : [];
//   }
// );

// export const getFlags = createSelector(
//   [selectData],
//   (data) => {
//     const filteredGroup = data?.genericMasterFilteredList?.filter(item => item.type === "Flag");
//     return filteredGroup && filteredGroup.length > 0 ? filteredGroup[0]?.data || [] : [];
//   }
// );

// export const getPriorities = createSelector(
//   [selectData],
//   (data) => {
//     const filteredGroup = data?.genericMasterFilteredList?.filter(item => item.type === "Priority");
//     return filteredGroup && filteredGroup.length > 0 ? filteredGroup[0]?.data || [] : [];
//   }
// );

// export const getProjectTypes = createSelector(
//   [selectData],
//   (data) => {
//     const filteredGroup = data?.genericMasterFilteredList?.filter(item => item.type === "ProjectType");
//     return filteredGroup && filteredGroup.length > 0 ? filteredGroup[0]?.data || [] : [];
//   }
// );

// export const getTaskTags = createSelector(
//   [selectData],
//   (data) => {
//     const filteredGroup = data?.genericMasterFilteredList?.filter(item => item.type === "TaskTag");
//     return filteredGroup && filteredGroup.length > 0 ? filteredGroup[0]?.data || [] : [];
//   }
// );

// export const getAssignmentBillingStatus = createSelector(
//   [selectData],
//   (data) => {
//     const filteredGroup = data?.genericMasterFilteredList?.filter(item => item.group === "AssignmentBilling");
//     return filteredGroup && filteredGroup.length > 0 ? filteredGroup[0]?.data || [] : [];
//   }
// );

// export const getProjectBillingStatus = createSelector(
//   [selectData],
//   (data) => {
//     const filteredGroup = data?.genericMasterFilteredList?.filter(item => item.group === "ProjectBilling");
//     return filteredGroup && filteredGroup.length > 0 ? filteredGroup[0]?.data || [] : [];
//   }  );

export const getLoggedUserRMData = createSelector(
  [selectData],
  (data) => data?.loggedUserRMData?.associateRms?.[0] || []
);

export const getOwners = createSelector([selectData], (data) =>
  data.owners ? data.owners.userList : []
);

export const getActiveOwners = createSelector([selectData], (data) =>
  data.owners ? data.owners.userList.filter((user) => user.isActive) : []
);

export const getGeographyNodes = createSelector([selectData], (data) =>
  data.geographyNodes ? data.geographyNodes.geographyNodes : []
);

export const getOrgUnitNodes = createSelector([selectData], (data) =>
  data.orgUnitNodes ? data.orgUnitNodes.orgUnitNodes : []
);

export const getUser = createSelector([selectData], (data) => (data.user ? data.user : []));

export const getAllUserActivity = createSelector([selectData], (data) => (data?.userActivity?.userActivities ? data?.userActivity?.userActivities : []));

export const getClients = createSelector([selectData], (data) => data.clients?.clients || []);

export const getFinalDataWithRMName = createSelector(
  [selectData],
  (data) => data.finalDataWithRMName || []
);

export const getUserTimelogSettingsById = createSelector(
  [selectUserTimelogSettings],
  (data) => data?.userTimeLogSettings?.userTimeLogSettings || []
);

export const getBillingTypes = createSelector([selectData], (data) => data.billingTypes || []);

export const getCustomFieldByEntity = createSelector([selectData], (data) =>
  data.customFieldByEntity ? data.customFieldByEntity.customFieldsList : []
);

export const getAssignments = createSelector([selectData], (data) =>
  data.assignments ? data.assignments.assignments : []
);

// export const getGenericMasterFilteredList = createSelector(
//   [selectData],
//   (data) => (data && data.length > 0 ? data : [])
// );

export const getMasterProjects = createSelector([selectData], (data) =>
  data.masterProjects ? data.masterProjects.masterProjects : []
);

export const getFeatures = createSelector([selectData], (data) =>
  data.milestones ? data.milestones.milestones : []
);
export const getAssignmentsByProject = createSelector([selectData], (data) =>
  data.assignmentByProject ? data.assignmentByProject.assignments : []
);

export const getTimeSheetPageLoader = createSelector([selectPageLoader], (loader) => {
  return loader.timesheets ? loader.timesheets : null;
});

export const getAssignmentPageLoader = createSelector([selectPageLoader], (loader) => {
  return loader.assignments ? loader.assignments : null;
});

export const getProjectPageLoader = createSelector([selectPageLoader], (loader) => {
  return loader.projects ? loader.projects : null;
});

export const getFeaturePageLoader = createSelector([selectPageLoader], (loader) => {
  return loader.milestones ? loader.milestones : null;
});

export const getAssignmentTotalCount = createSelector([selectData], (data) =>
  data.assignments ? data.assignments.totalCount : 0
);

export const getFeatureTotalCount = createSelector([selectData], (data) =>
  data.milestones ? data.milestones.totalCount : 0
);

export const getRecentAssignmentsByUserId = createSelector(
  [selectData],
  (data) =>
    (data?.recentAssignmentsByUserId?.recentAssignments?.length > 0 &&
      data?.recentAssignmentsByUserId?.recentAssignments) ||
    []
);

export const getClientTotalCount = createSelector([selectData], (data) =>
  data.clients ? data.clients.totalCount : 0
);

export const getClientPageLoader = createSelector([selectPageLoader], (loader) => {
  return loader.projects ? loader.projects : null;
});

export const getProjectTotalCount = createSelector([selectData], (data) =>
  data.projects ? data.projects.totalCount : 0
);

export const getTimeSheetList = createSelector([selectData], (data) =>
  data.timesheets ? data.timesheets.timesheets : []
);

export const getTimeSheetListTotalCount = createSelector([selectData], (data) =>
  data.timesheets ? data.timesheets.totalCount : 0
);

export const getTimeSheetListTotalBillingHours = createSelector([selectData], (data) =>
  data.timesheets ? data.timesheets.totalLoggedHours : 0
);

export const getTimesheetByDate = createSelector([selectData], (data) =>
  data.TimesheetListByDate ? data.TimesheetListByDate.timesheets : []
);

export const getReportClientDropdown = createSelector([selectData], (data) =>
  data?.reportsDropdown?.client ? data?.reportsDropdown?.client : []
);

export const getReportProjectDropdown = createSelector([selectData], (data) =>
  data?.reportsDropdown?.project ? data?.reportsDropdown?.project : []
);

export const getReportUserDropdown = createSelector([selectData], (data) =>
  data?.reportsDropdown?.user ? data?.reportsDropdown?.user : []
);

export const getEventList = createSelector([selectData], (data) =>
  data.EventList ? data.EventList.timesheets : []
);
export const getGridDataByModuleKey = (module) =>
  createSelector([selectData], (data) => (data[module] ? data[module] : {}));

export const getLeadList = createSelector([selectData], (data) =>
  data.leads ? data.leads.leads : []
);
// export const getLeadById = createSelector(
//   [selectData, (_, leadId) => leadId],
//   (data, leadId) => {
//     return data.leads?.leads?.find((lead) => lead.id === leadId) || null;
//   }
// );
export const getLeadById = createSelector([selectData, (_, leadId) => leadId], (data, leadId) => {
  if (data.leads?.details) return data.leads?.details[leadId] || null;
  return null;
});

export const getSalesById = createSelector(
  [selectData, (_, salesId) => salesId],
  (data, salesId) => {
    console.log('data 556 ', data);
    // return data?.salesOrder?.saleOrders?.find((sales) => sales.id === salesId) ||  null;
    if (data.salesOrder?.details) return data.salesOrder?.details[salesId] || null;
    return null;
  }
);

export const getInvoiceById = createSelector(
  [selectData, (_, invoiceId) => invoiceId],
  (data, invoiceId) => {
    // return data?.invoice?.invoices?.find((invoice) => invoice.id === invoiceId) ||  null;
    if (data.invoice?.details) return data.invoice?.details[invoiceId] || null;
    return null;
  }
);

export const getOpportunityById = createSelector(
  [selectData, (_, opportunityId) => opportunityId],
  (data, opportunityId) => {
    // return (
    //   data.opportunityList?.opportunity?.find((opportunity) => opportunity.id === opportunityId) ||
    //   null
    // );
    if (data.opportunityList?.details) return data.opportunityList?.details[opportunityId] || null;
    return null;
  }
);

export const getContactById = createSelector(
  [selectData, (_, contactId) => contactId],
  (data, contactId) => {
    // return data.contactList?.contacts?.find((contacts) => contacts.id === contactId) || null;
    if (data.contactList?.details) return data.contactList?.details[contactId] || null;
    return null;
  }
);

export const getAccountById = createSelector(
  [selectData, (_, accountId) => accountId],
  (data, accountId) => {
    // return data.accountList?.account?.find((account) => account.id === accountId) || null;
    if (data.accountList?.details) return data.accountList?.details[accountId] || null;
    return null;
  }
);

export const getCampaignById = createSelector(
  [selectData, (_, campaignId) => campaignId],
  (data, campaignId) => {
    // return data.campaignList?.campaign?.find((campaign) => campaign.id === campaignId) || null;
    if (data.campaignList?.details) return data.campaignList?.details[campaignId] || null;
    return null;
  }
);

export const getTicketById = createSelector(
  [selectData, (_, ticketId) => ticketId],
  (data, ticketId) => {
    // return data.ticketList?.ticket?.find((ticket) => ticket.id === ticketId) || null;
    if (data.ticketList?.details) return data.ticketList?.details[ticketId] || null;
  }
);

export const getCampaignList = createSelector([selectData], (data) =>
  data.campaignList ? data.campaignList.campaign : []
);
export const getContactList = createSelector([selectData], (data) =>
  data.contactList ? data.contactList.contacts : []
);

export const getAccountList = createSelector([selectData], (data) =>
  data.accountList ? data.accountList.account : []
);

// export const getRevenueTypeList = createSelector(
//   [selectData],
//   (data) => data.revenueTypeList ? data.revenueTypeList : []
// );

// export const getLeadSourceList = createSelector(
//   [selectData],
//   (data) => data.leadSourceList ? data.leadSourceList : []
// );

// export const getIndustryList = createSelector(
//   [selectData],
//   (data) => data.industryList ? data.industryList : []
// );

// export const getAccountType = createSelector(
//   [selectData],
//   (data) => data.accountType ? data.accountType : []
// );

// export const getCampaignType = createSelector(
//   [selectData],
//   (data) => data.campaignType ? data.campaignType : []
// );

// export const getCampaignStatus = createSelector(
//   [selectData],
//   (data) => data.campaignStatus ? data.campaignStatus : []
// );

// export const getTicketPriority = createSelector(
//   [selectData],
//   (data) => data.ticketPriority ? data.ticketPriority : []
// );

// export const getTimeZone = createSelector(
//   [selectData],
//   (data) => data.timeZone ? data.timeZone : []
// );

// export const getSalutation = createSelector(
//   [selectData],
//   (data) => data.salutation ? data.salutation : []
// );

// export const getContactPersonRole = createSelector(
//   [selectData],
//   (data) => data.contactPersonRole ? data.contactPersonRole : []
// );

// export const getStage = createSelector(
//   [selectData],
//   (data) => data.stage ? data.stage : []
// );

// export const getCampaignSource = createSelector(
//   [selectData],
//   (data) => data.campaignSource ? data.campaignSource : []
// );

// export const getCampaignMemberStatus = createSelector(
//   [selectData],
//   (data) => data.campaignMemberStatus ? data.campaignMemberStatus : []
// );

// export const getTicketStatus = createSelector(
//   [selectData],
//   (data) => data.ticketStatus ? data.ticketStatus : []
// );

// export const getForecastCategory = createSelector(
//   [selectData],
//   (data) => data.forecastCategory ? data.forecastCategory : []
// );

// export const getProjectTypeCrm = createSelector(
//   [selectData],
//   (data) => data.projectTypeCrm ? data.projectTypeCrm : []
// );

export const getMeetingsList = createSelector([selectData], (data) =>
  data.meetingsList ? data.meetingsList.meetings : []
);

export const getOpportunityList = createSelector([selectData], (data) =>
  data.opportunityList ? data.opportunityList.opportunity : []
);

export const getTicketList = createSelector([selectData], (data) =>
  data.ticketList ? data.ticketList.ticket : []
);

export const getCallsList = createSelector([selectData], (data) =>
  data.callsList ? data.callsList.calls : []
);

export const getTagsByModule = (moduleName) =>
  createSelector([selectData], (data) => (data[moduleName] ? data[moduleName].tags : []));

// export const getLeadtag = createSelector([selectData], (data) =>
//   data.leadTag ? data.leadTag.tags : []
// );

export const getAllTemplate = createSelector([selectData], (data) =>
  data.template ? data.template.template : null
);

export const getLeadPageLoader = createSelector([selectPageLoader], (loader) => {
  return loader.leads ? loader.leads : null;
});
// export const getAccountPageLoader = createSelector(
//   [selectPageLoader],
//   (loader) => {
//     return loader.account ? loader.account : null
//   }
// );

export const getleadTotalCount = createSelector([selectData], (data) =>
  data.leads ? data.leads.totalCount : 0
);

export const getUserList = createSelector([selectData], (data) => {
  const raw = data.userList;
  if (!raw) return [];
  return Array.isArray(raw) ? raw : raw?.userList || raw?.users || raw?.data || [];
});
export const getLeadsDropdown = createSelector([selectData], (data) =>
  data.leadDropdown ? data?.leadDropdown?.leadList : []
);

export const getAccountsDropdown = createSelector([selectData], (data) =>
  data?.accountDropdown?.accountList ? data?.accountDropdown?.accountList : []
);

export const getContactsDropdown = createSelector([selectData], (data) =>
  data?.contactDropdown?.contactList ? data?.contactDropdown?.contactList : []
);

export const getOpportunityDropdown = createSelector([selectData], (data) =>
  data?.opportunityDropdown?.opportunityList ? data?.opportunityDropdown?.opportunityList : []
);

export const getCampaignDropdownLead = createSelector([selectData], (data) =>
  data?.campaignDropdownLead?.campaignList ? data?.campaignDropdownLead?.campaignList : []
);

export const getCampaignDropdownContact = createSelector([selectData], (data) =>
  data?.campaignDropdownContact?.campaignList ? data?.campaignDropdownContact?.campaignList : []
);
export const getProductDropdown = createSelector([selectData], (data) =>
  data?.productDropdown?.productList ? data?.productDropdown?.productList : []
);

export const getMassEmailByModuleKey = (module) =>
  createSelector([selectData], (data) => (data[module] ? data[module]?.emails : null));

export const getMassEmailCountByModuleKey = (module) =>
  createSelector([selectData], (data) => (data[module] ? data[module]?.totalCount : 0));

// export const getContactTotalCount = createSelector(
//   [selectData],
//   (data) => data.contacts ? data.contacts.totalCount : 0
// );
// export const getAccountTotalCount = createSelector(
//   [selectData],
//   (data) => data.accountList ? data.accountList.totalCount : 0
// );

export const getQuoteList = createSelector([selectData], (data) =>
  data.quoteList ? data.quoteList.quote : []
);

export const getPolicyQuoteList = createSelector([selectData], (data) =>
  data.policyQuoteList
    ? data.policyQuoteList.policyQuotes
    : []
);

export const getSalesOrder = createSelector([selectData], (data) =>
  data.salesOrder ? data.salesOrder.saleOrders : []
);

export const getInvoice = createSelector([selectData], (data) =>
  data.invoice ? data.invoice.invoices : []
);

export const getProductList = createSelector([selectData], (data) =>
  data.productList ? data.productList.product : []
);

export const getPriceList = createSelector([selectData], (data) =>
  data.priceSheetList ? data.priceSheetList.priceSheet : []
);
export const getQuoteById = createSelector(
  [selectData, (_, quoteId) => quoteId],
  (data, quoteId) => {
    if (data.quoteList?.details) return data.quoteList?.details[quoteId] || null;
    return null;
  }
);

export const getProductById = createSelector(
  [selectData, (_, productId) => productId],
  (data, productId) => {
    if (data.productList?.details) return data.productList?.details[productId] || null;
    return null;
  }
);

export const getPriceSheetById = createSelector(
  [selectData, (_, priceSheetId) => priceSheetId],
  (data, priceSheetId) => {
    if (data.priceSheetList?.details) return data.priceSheetList?.details[priceSheetId] || null;
    return null;
  }
);

export const getProductReferenceLookupByKey = (key) =>
  createSelector([selectData], (data) =>
    data?.productReferenceLookup && key in data?.productReferenceLookup
      ? data?.productReferenceLookup[key]
      : []
  );
export const getSmartSequence = createSelector([selectData], (data) =>
  data.smartSequence ? data.smartSequence.sequenceDetailsList : []
);
export const getZohoCampaigns = createSelector([selectData], (data) =>
  data.zohoCampaigns ? data.zohoCampaigns : []
);

export const getAuditLogs = createSelector([selectData], (data) =>
  data.auditLogs?.publishEventData ? data.auditLogs?.publishEventData : []
);
export const getAuditLogTotalCount = createSelector([selectData], (data) =>
  data.auditLogs ? data.auditLogs.totalCount : 0
);